import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { HttpClient } from "../../../api/httpClient";
import { DEFAULT_ENTITY_STATE } from "../../utils";

const baseName = "customFields";

const initialState = DEFAULT_ENTITY_STATE;

export const getCustomFields = createAsyncThunk(
  `${baseName}/getCustomFields`,
  async () => {
    const res = await HttpClient.get({
      url: "/customFields",
      params: {
        role: "admin",
      },
    });
    return res?.data || [];
  }
);

export const customFieldsSlice = createSlice({
  name: baseName,
  initialState,
  reducers: {
    setupCustomFields(state, { payload }) {
      state.data = payload?.map((item) => ({ ...item, id: item?._id })) || [];
    },

    resetCustomFieldsStatus(state) {
      state.status = "idle";
    },

    addCustomField(state, { payload }) {
      state.data.push(payload);
    },
    updateCustomField(state, { payload }) {
      const { id, changes } = payload;
      const index = state.data.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.data[index] = {
          ...state.data[index],
          ...changes,
        };
      }
    },
    removeCustomField(state, { payload }) {
      state.data = [...state.data?.filter((item) => item?.id !== payload)];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomFields.pending, (state, action) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getCustomFields.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || null;
      })
      .addCase(getCustomFields.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;

        //Dados API
        const data = action.payload || [];
        customFieldsSlice.caseReducers.setupCustomFields(state, {
          payload: data,
        });
      });
  },
});

export const {
  addCustomField,
  removeCustomField,
  setupCustomFields,
  updateCustomField,
  resetCustomFieldsStatus,
} = customFieldsSlice.actions;

export default customFieldsSlice.reducer;

export const selectAdminCustomFields = createSelector(
  [(state) => state.customFields],
  (state = {}) => {
    const prevData = state || DEFAULT_ENTITY_STATE;
    return {
      ...prevData,
      total: prevData?.data?.length || 0,
    };
  }
);

export const selectAdminCustomFieldById = createSelector(
  [selectAdminCustomFields, (state, fieldId) => fieldId],
  (state = {}, fieldId = "") => {
    return state?.data?.find((item) => item?.id === fieldId) || {};
  }
);
